import { defineStore } from "pinia";
import { computed, ref } from "vue";
import type { processedAddressObj } from "./types";

export const useAddressLookupStore = defineStore("addressLookupStore", () => {

  // ---------------------------------- State --------------------------------- //

  const history = ref<processedAddressObj[]>([]);

  // --------------------------------- Getters -------------------------------- //

  const addressSearchHistory = computed<processedAddressObj[]>(
    () => history.value,
  );

  // --------------------------------- Actions -------------------------------- //

  function addToAddressSearchHistory(address: processedAddressObj) {
    const exists = history.value.some((item) =>
      item.coordinates.isSameLocation(address.coordinates),
    );

    if (exists) return;

    history.value.unshift({
      ...address,
      isHistoryItem: true,
    });
  }

  function $reset() {
    history.value = []
  }

  return {
    // -------------------------------- Getters ------------------------------- //

    /** Returns this sessions address search history in order of most recent first. */
    addressSearchHistory,
    
    // -------------------------------- Actions ------------------------------- //

    /** Adds a processed address object to the applications search history. */
    addToAddressSearchHistory,

    /** Resets the store to its initial state. */
    $reset,
  };
});
